import { API } from "./utils"

export const fees = {
  feesList: (params = null) => API.get("/distributions/fees/", { params }),
  createFee: (data) => API.post("/distributions/fees/", data),
  getFee: (id) => API.get(`/distributions/fees/${id}/`),
  updateFee: (id, data) => API.patch(`distributions/fees/${id}/`, data),
  deleteFee: (id) => API.delete(`/distributions/fees/${id}/`),
}
